export const emptyCollectionsSection = (clearFilters = true) => async dispatch => {
	if (clearFilters) dispatch({type: 'FETCH_COLLECTIONS_FILTERS', payload: []});
}